import useValidateAutoCreditOtp from './hooks/useValidateAutoCreditOtp';

export { useValidateAutoCreditOtp };
